type WorkExperienceForPreview = {
  title: string;
  company_name: string;
  custom_role_title?: string;
  custom_company_name?: string;
};

type PreviewWorkExperience<T extends WorkExperienceForPreview> = Omit<
  T,
  "custom_role_title" | "custom_company_name"
> & {
  title: string;
  company_name: string;
};

export const mapWorkExperiencesForPreview = <T extends WorkExperienceForPreview>(
  workExperiences: T[] | undefined
): PreviewWorkExperience<T>[] =>
  (workExperiences ?? []).map(({ custom_role_title, custom_company_name, ...workExperience }) => ({
    ...workExperience,
    title: custom_role_title ?? workExperience.title,
    company_name: custom_company_name ?? workExperience.company_name,
  }));
